import { Box, styled, Typography } from '@mui/material';
import { FC } from 'react';

import { GridColumn } from './types';

export type ScheduleGridHeaderProps = {
  days: GridColumn[];
  showTimeColumn?: boolean;
};

export const ScheduleGridHeader: FC<ScheduleGridHeaderProps> = ({ days, showTimeColumn }) => {
  return (
    <Box
      sx={{
        gridColumn: '1 / -1',
        display: 'grid',
        gridTemplateColumns: 'subgrid',
      }}
    >
      {showTimeColumn && (
        <ScheduleGridHeaderCell
          sx={(theme) => ({
            position: 'sticky',
            top: 0,
            zIndex: theme.zIndex.drawer,
            border: 'none',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 'auto',
              bottom: 0,
              right: 0,
              width: theme.spacing(1),
              borderTop: theme.mixins.borderValue(),
            },
          })}
        />
      )}
      {days.map((day, index) => (
        <ScheduleGridHeaderCell
          key={day.value}
          sx={(theme) => ({
            position: 'sticky',
            top: 0,
            zIndex: theme.zIndex.drawer,
            ...(index === days.length - 1 ? { borderRight: 'none' } : {}),
          })}
        >
          <Typography
            sx={(theme) => ({
              color: theme.palette.common.grey,
              textTransform: 'uppercase',
            })}
          >
            {day.label}
          </Typography>
        </ScheduleGridHeaderCell>
      ))}
    </Box>
  );
};

export const ScheduleGridHeaderCell = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(0.25),
  borderBottom: theme.mixins.borderValue(),
  borderRight: theme.mixins.borderValue(),
  backgroundColor: theme.palette.background.paper,
}));
